import { render, staticRenderFns } from "./UserTabsDetails.vue?vue&type=template&id=79177d6a"
import script from "./UserTabsDetails.vue?vue&type=script&lang=js"
export * from "./UserTabsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports